
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// import API, { auth, apikey } from '../../constants/api';
import API from '../../constants/api';
import {
	MENU_FETCH,
	MENU_STATE
} from '../actions';

import {
	menuSuccess,
	menuFail,
} from './actions';
import { sortOrder} from '../../helpers/Utils';

const menuFetchAsync = async (data) =>
await API.post('/user/menulist', {
	userId: data.user_id,
 } ,
 {
	headers : {
	  'Content-Type': 'application/json',
	  'apikey': '87cdf9229caf9a7fa3fd1403bcc5dd97'
	}
 })
	  .then(data => data)
	  .catch(error => error);

//* Get Device List
function* menuFetch({ payload }) {

	try {
		const { menulist } = payload;
		const menuFetch = yield call(menuFetchAsync, menulist);
		if (menuFetch.data.StatusCode === "0000") {
			let menuData = menuFetch.data.ResultValues.sort(sortOrder('id','asc'))

			yield put(menuSuccess(menuData));
		} else {
			yield put(menuFail(menuFetch.data.Message));
		}
	} catch (error) {
		yield put(menuFail(error));
	}
}


export function* watchDeviceFetch() {
	yield takeEvery(MENU_FETCH, menuFetch)

}

export default function* rootSaga() {
	yield all([
		fork(watchDeviceFetch),
	]);
}
